import React from 'react';
import BusinessSearchExperience from '../BusinessSearchExperience';

const CastingPhase = ({
  searchMethod,
  setSearchMethod,
  selectedBusiness,
  selectedPlaceId,
  onPlaceSelect,
  onStartProject,
  currentOrg,
  selectedAdvertiserId,
  setSelectedAdvertiserId,
  apiError,
  loading,
}) => {
  return (
    <div className="flex min-h-0 flex-1 overflow-auto">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-6">
        <BusinessSearchExperience
          title="Start Your Production"
          subtitle="Search on Google Maps or paste a website URL to open a standalone Director job with the business context already loaded."
          searchMethod={searchMethod}
          setSearchMethod={setSearchMethod}
          selectedPlaceId={selectedPlaceId}
          selectedBusiness={selectedBusiness}
          isLoading={loading}
          error={apiError}
          currentOrg={currentOrg}
          selectedAdvertiserId={selectedAdvertiserId}
          setSelectedAdvertiserId={setSelectedAdvertiserId}
          onPlaceSelect={onPlaceSelect}
          onSubmitSource={onStartProject}
          ctaLabel="Start Director Job"
          ctaLoadingLabel="Starting Director..."
          footerSlot={
            <p className="text-xs text-center text-muted-foreground pt-2 opacity-50">
              Separate creative flow &bull; Shared business search &bull; Job-based bootstrap
            </p>
          }
        />
      </div>
    </div>
  );
};

export default CastingPhase;
